<div [formGroup]="schoolInfoService.schoolForm" class="school-form" *ngIf="booking">
  <h2 i18n>SCHOOL FORM</h2>
  <label i18n>
    Last name:
  </label>
  {{booking!.student.firstName!}}
  <label i18n>
    First name:
  </label>
  {{booking!.student.lastName!}}
  <label i18n>
    Learns Dutch at school*
  </label>
  <div class="radio-box">
    <div class="radio-item">
      <input type="radio" [value]="true" formControlName="studyDutchInSchool" id="study-dutch-in-school">
      <p i18n>
        Yes
      </p>

    </div>
    <div class="radio-item">
      <input type="radio" [value]="false" formControlName="studyDutchInSchool" id="do-not-study-dutch-in-school">
      <p i18n>
        No
      </p>
    </div>
    <div i18n class="warning"
    *ngIf="(schoolInfoService.schoolForm.value.studyDutchInSchool == null && submitFail)">
    This information can not be empty.
  </div>
  </div>

  <div *ngIf="schoolInfoService.schoolForm.get('studyDutchInSchool')!.value">
    <label i18n>
      If yes, how many years
    </label>
  </div>
  <div *ngIf="schoolInfoService.schoolForm.get('studyDutchInSchool')!.value">
    <select formControlName="dutchStudyYears" id="dutch-study-years">
      <option value="1">1</option>
      <option value="2">2</option>
      <option value="3">3</option>
      <option value="4">4</option>
      <option value="5">5</option>
      <option value="6">6</option>
      <option value="7">7</option>
      <option value="8">8</option>
      <option value="9">9</option>
      <option value="10">10</option>
    </select>
  </div>

  <div *ngIf="schoolInfoService.schoolForm.value.studyDutchInSchool" class="first-column">
    <label i18n>
      Number of Dutch lessons per week:
    </label>
  </div>
  <div *ngIf="schoolInfoService.schoolForm.value.studyDutchInSchool" class="second-column">
    <select formControlName="dutchStudyHours" id="dutch-study-hours">
      <option value="1">1</option>
      <option value="2">2</option>
      <option value="3">3</option>
      <option value="4">4</option>
      <option value="5">5</option>
      <option value="10">10</option>
      <option value="15">15</option>
      <option value="20">20</option>
      <option value="25">25</option>
      <option value="30">30</option>
      <option value="35">35</option>
    </select>
  </div>

  <div *ngIf="schoolInfoService.schoolForm.value.studyDutchInSchool" class="first-column">
    <label i18n>
      Name of the Dutch teacher: Mr/Ms
    </label>
  </div>
  <div *ngIf="schoolInfoService.schoolForm.value.studyDutchInSchool" class="second-column">
    <input pInputText type="text" formControlName="dutchTeacherName" id="dutch-teacher-name">
    <div i18n class="warning"
      *ngIf="(schoolInfoService.schoolForm.errors && !['missingDutchStudyInfo'] && schoolInfoService.schoolForm.get('dutchTeacherName')!.touched) || 
      (schoolInfoService.schoolForm.errors && schoolInfoService.schoolForm.errors!['missingDutchStudyInfo'] && submitFail)">
      Information on Dutch study is missing.
    </div>
  </div>


  <label i18n>
    Learns English at school*
  </label>
  <div class="radio-box">
    <div class="radio-item">
      <input type="radio" [value]="true" formControlName="studyEnglishInSchool" id="study-english-in-school">
      <p i18n>
        Yes
      </p>
    </div>
    <div class="radio-item">
      <input type="radio" [value]="false" formControlName="studyEnglishInSchool" id="do-not-study-english-in-school">
      <p i18n>
        No
      </p>

    </div>
    <div i18n class="warning"
    *ngIf="(schoolInfoService.schoolForm.value.studyEnglishInSchool == null && submitFail)">
    This information can not be empty.
  </div>
  </div>

  <div *ngIf="schoolInfoService.schoolForm.get('studyEnglishInSchool')!.value">
    <label i18n>
      If yes, how many years
    </label>
  </div>
  <div *ngIf="schoolInfoService.schoolForm.get('studyEnglishInSchool')!.value">
    <select formControlName="englishStudyYears" id="english-study-years">
      <option value="1">1</option>
      <option value="2">2</option>
      <option value="3">3</option>
      <option value="4">4</option>
      <option value="5">5</option>
      <option value="6">6</option>
      <option value="7">7</option>
      <option value="8">8</option>
      <option value="9">9</option>
      <option value="10">10</option>
    </select>
  </div>

  <div *ngIf="schoolInfoService.schoolForm.value.studyEnglishInSchool" class="first-column">
    <label i18n>
      Number of English lessons per week:
    </label>
  </div>
  <div *ngIf="schoolInfoService.schoolForm.value.studyEnglishInSchool" class="second-column">
    <select formControlName="englishStudyHours" id="english-study-hours">
      <option value="1">1</option>
      <option value="2">2</option>
      <option value="3">3</option>
      <option value="4">4</option>
      <option value="5">5</option>
      <option value="10">10</option>
      <option value="15">15</option>
      <option value="20">20</option>
      <option value="25">25</option>
      <option value="30">30</option>
      <option value="35">35</option>
    </select>
  </div>

  <div *ngIf="schoolInfoService.schoolForm.value.studyEnglishInSchool" class="first-column">
    <label i18n>
      Name of the English teacher: Mr/Ms
    </label>
  </div>
  <div *ngIf="schoolInfoService.schoolForm.value.studyEnglishInSchool" class="second-column">
    <input pInputText type="text" formControlName="englishTeacherName" id="english-teacher-name">
    <div i18n class="warning"
      *ngIf="(schoolInfoService.schoolForm.errors && schoolInfoService.schoolForm.errors!['missingEnglishStudyInfo'] && schoolInfoService.schoolForm.get('englishTeacherName')!.touched) || 
      (schoolInfoService.schoolForm.errors && schoolInfoService.schoolForm.errors!['missingEnglishStudyInfo'] && submitFail)">
      Information on English study is missing.
    </div>
  </div>

  <label i18n>
    Learns French at school*
  </label>
  <div class="radio-box">
    <div class="radio-item">
      <input type="radio" [value]="true" formControlName="studyFrenchInSchool" id="study-french-in-school">
      <p i18n>
        Yes
      </p>
    </div>
    <div class="radio-item">
      <input type="radio" [value]="false" formControlName="studyFrenchInSchool" id="do-not-study-french-in-school">
      <p i18n>
        No
      </p>
    </div>
    <div i18n class="warning"
    *ngIf="(schoolInfoService.schoolForm.value.studyFrenchInSchool == null && submitFail)">
    This information can not be empty.
  </div>
  </div>

  <div *ngIf="schoolInfoService.schoolForm.get('studyFrenchInSchool')!.value">
    <label i18n>
      If yes, how many years
    </label>
  </div>

  <div *ngIf="schoolInfoService.schoolForm.get('studyFrenchInSchool')!.value">
    <select formControlName="frenchStudyYears" id="french-study-years">
      <option value="1">1</option>
      <option value="2">2</option>
      <option value="3">3</option>
      <option value="4">4</option>
      <option value="5">5</option>
      <option value="6">6</option>
      <option value="7">7</option>
      <option value="8">8</option>
      <option value="9">9</option>
      <option value="10">10</option>
    </select>
  </div>

  <div *ngIf="schoolInfoService.schoolForm.value.studyFrenchInSchool" class="first-column">
    <label i18n>
      Number of French lessons per week:*
    </label>
  </div>
  <div *ngIf="schoolInfoService.schoolForm.value.studyFrenchInSchool" class="second-column">
    <select formControlName="frenchStudyHours" id="french-study-hours">
      <option value="1">1</option>
      <option value="2">2</option>
      <option value="3">3</option>
      <option value="4">4</option>
      <option value="5">5</option>
      <option value="10">10</option>
      <option value="15">15</option>
      <option value="20">20</option>
      <option value="25">25</option>
      <option value="30">30</option>
      <option value="35">35</option>
    </select>
  </div>

  <div *ngIf="schoolInfoService.schoolForm.value.studyFrenchInSchool" class="first-column">
    <label i18n>
      Name of the French teacher: Mr/Mme*
    </label>
  </div>
  <div *ngIf="schoolInfoService.schoolForm.value.studyFrenchInSchool" class="second-column">
    <input pInputText type="text" formControlName="frenchTeacherName" id="french-teacher-name">
    <div i18n class="warning"
      *ngIf="(schoolInfoService.schoolForm.errors && schoolInfoService.schoolForm.errors!['missingFrenchStudyInfo'] && schoolInfoService.schoolForm.get('frenchTeacherName')!.touched) || 
      (schoolInfoService.schoolForm.errors && schoolInfoService.schoolForm.errors!['missingFrenchStudyInfo'] && submitFail)">
      Information on French study is missing.
    </div>
  </div>

  <label i18n>
    Do you ever speak the selected language at home?*
  </label>
  <div class="radio-box">
    <div class="radio-item">
      <input type="radio" [value]="frequencies[1]" formControlName="frequencySpeakingWithFamily" id="often-speak-at-home">
      <p i18n>
        often
      </p>
    </div>
    <div class="radio-item">
      <input type="radio" [value]="frequencies[2]" formControlName="frequencySpeakingWithFamily" id="sometimes-speak-at-home">
      <p i18n>
        sometimes
      </p>
    </div>
    <div class="radio-item">
      <input type="radio" [value]="frequencies[0]" formControlName="frequencySpeakingWithFamily" id="never-speak-at-home">
      <p i18n>
        never
      </p>
    </div>
    <div i18n class="warning"
    *ngIf="(schoolInfoService.schoolForm.value.frequencySpeakingWithFamily == null && submitFail)">
    This information can not be empty.
  </div>
  </div>

  <label i18n>
    With friends and relatives?*
  </label>

  <div class="radio-box">
    <div class="radio-item">
      <input type="radio" [value]="frequencies[1]" formControlName="frequencySpeakingWithFriends" id="often-speak-with-friends">
      <p i18n>
        often
      </p>
    </div>
    <div class="radio-item">
      <input type="radio" [value]="frequencies[2]" formControlName="frequencySpeakingWithFriends" id="sometimes-speak-with-friends">
      <p i18n>
        sometimes
      </p>
    </div>
    <div class="radio-item">
      <input type="radio" [value]="frequencies[0]" formControlName="frequencySpeakingWithFriends" id="never-speak-with-friends">
      <p i18n>
        never
      </p>
    </div>
    <div i18n class="warning"
    *ngIf="(schoolInfoService.schoolForm.value.frequencySpeakingWithFriends == null && submitFail)">
    This information can not be empty.
  </div>
  </div>

  <label i18n>
    Does your child experience difficulties with the target language?*
  </label>

  <div class="radio-box">
    <div class="radio-item">
      <input type="radio" [value]="true" formControlName="hasLearningDifficulty" id="has-learning-difficulty">
      <p i18n>
        Yes
      </p>
    </div>

    <div class="radio-item">
      <input type="radio" [value]="false" formControlName="hasLearningDifficulty" id="has-no-learning-difficulty">
      <p i18n>
        No
      </p>
    </div>
    <div i18n class="warning"
    *ngIf="(schoolInfoService.schoolForm.value.hasLearningDifficulty == null && submitFail)">
    This information can not be empty.
  </div>
  </div>

  <label i18n>
    Has your child ever had to repeat an exam in the target language?*
  </label>

  <div class="radio-box">
    <div class="radio-item">
      <input type="radio" [value]="true" formControlName="hadLanguageTest" id="had-language-test">
      <p i18n>
        Yes
      </p>
    </div>
    <div class="radio-item">
      <input type="radio" [value]="false" formControlName="hadLanguageTest" id="had-no-language-test">
      <p i18n>
        No
      </p>
    </div>
    <div i18n class="warning"
    *ngIf="(schoolInfoService.schoolForm.value.hadLanguageTest == null && submitFail)">
    This information can not be empty.
  </div>
  </div>

  <div *ngIf="schoolInfoService.schoolForm.get('hadLanguageTest')!.value">
    <label i18n>
      if yes, when?*
    </label>
  </div>
  <div *ngIf="schoolInfoService.schoolForm.get('hadLanguageTest')!.value">
    <p-calendar [locale]="locale" formControlName="languageTestDate" [monthNavigator]="true" [yearNavigator]="true"
      yearRange="1990:2020" dateFormat="dd/mm/yy" [showOtherMonths]="false" id="language-test-date"></p-calendar>
    <div i18n class="warning"
      *ngIf="(schoolInfoService.schoolForm.errors && schoolInfoService.schoolForm.errors!['testDateMissing'] && schoolInfoService.schoolForm.get('languageTestDate')!.touched) || 
      (schoolInfoService.schoolForm.errors && schoolInfoService.schoolForm.errors!['testDateMissing'] && submitFail)">
      The date of exam is missing.
    </div>
  </div>

  <label i18n>
    Which subject does he have to focus on?
  </label>
  <input pInputText type="text" formControlName="matterToReview" id="matter-to-review">

  <div class="first-column">
    <label i18n>
      Which book does your child use at school this year?
    </label>
  </div>

  <div class="second-column">
    <input pInputText type="text" formControlName="studyBookName" id="study-book-name">
  </div>


  <label i18n>
    Is your child coming along with one or several friends?*
  </label>

  <div class="radio-box">
    <div class="radio-item">
      <input type="radio" [value]="true" formControlName="isComingWithFriends" id="is-coming-with-friends">
      <p i18n>
        Yes
      </p>
    </div>

    <div class="radio-item">
      <input type="radio" [value]="false" formControlName="isComingWithFriends" id="is-not-coming-with-friends">
      <p i18n>
        No
      </p>
    </div>
    <div i18n class="warning"
    *ngIf="(schoolInfoService.schoolForm.value.isComingWithFriends == null && submitFail)">
    This information can not be empty.
  </div>
  </div>

  <div *ngIf="schoolInfoService.schoolForm.get('isComingWithFriends')!.value" class="first-column">
    <label i18n>
      If yes, who?*
    </label>
  </div>
  <div *ngIf="schoolInfoService.schoolForm.get('isComingWithFriends')!.value" class="second-column">
    <input pInputText formControlName="friendName" id="friend-name">
    <div i18n class="warning"
      *ngIf="(schoolInfoService.schoolForm.errors && schoolInfoService.schoolForm.errors!['friendNameMissing'] && schoolInfoService.schoolForm.get('friendName')!.touched) || 
      (schoolInfoService.schoolForm.errors && schoolInfoService.schoolForm.errors!['friendNameMissing'] && submitFail)">
      The friend's name can not be empty.
    </div>
  </div>
  <br>
  <div i18n class="warning" *ngIf="hasError">
    an error occurred while submitting the form.
  </div>